export class NotificationMessageCategory {
  static readonly SYSTEM: string = "SYSTEM";
  static readonly WORKFLOW: string = "WORKFLOW";
}
